export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/1d556993-a58d-43bc-bae6-ef5f64cff7ce.png"
              alt="REAL"
              className="h-12 w-auto mb-6"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              MADE IN JAPANによる<br />
              メガネブランド<br />
              洗練された究極のデザイン&カラー
            </p>
          </div>

          <div>
            <h3 className="font-['Noto_Serif_JP'] text-lg font-bold mb-4">ナビゲーション</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/"
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  トップページ
                </a>
              </li>
              <li>
                <a
                  href="https://www.1994real.com/catalog.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  カタログ
                </a>
              </li>
              <li>
                <a
                  href="https://ameblo.jp/real-inouefumihide/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  ブログ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-['Noto_Serif_JP'] text-lg font-bold mb-4">リンク</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://real1994.official.ec/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  オンラインストア
                </a>
              </li>
              <li>
                <a
                  href="https://ameblo.jp/real-inouefumihide/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  ブログ
                </a>
              </li>
              <li>
                <a
                  href="https://item.rakuten.co.jp/f082350-tsukubamirai/du35-40-nt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  ふるさと納税
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-['Noto_Serif_JP'] text-lg font-bold mb-4">フォローする</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/real_eyewear/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              copyright(c)REAL Corporation. ALL Rights Reserved.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
